import * as React from 'react';

const Spinner = ({ isActive }: { isActive: boolean }) => (
    isActive && <div className='loader-container'>
        <div className="loader"></div>
        <div className='loader-text'>Loading</div>
    </div>)

export default Spinner;